export const ErrorMessages: { [key: string]: string } = {
  "auth/invalid-email": "Please provide a valid email",
  "auth/email-already-in-use": "The provided email is already in use",
  "auth/user-not-found": "The account doesn't exists",
  "auth/wrong-password": "The password provided is not correct",
  "auth/weak-password": "The provided password is not secure",
  "auth/too-many-requests": "Request was blocked by provider. Try again later"
};
